<template>
  <v-form ref="form" lazy-validation @submit.prevent>
    <FormSection>
      <BaseSelect
        v-model="formData.damage"
        :class="['mb-6', $style.select]"
        :error-messages="damageErrors"
        :hide-details="!damageErrors.length"
        :label="$t('complaintForm.ticket.battery.damage')"
        :hint="
          $t('form.hint.selectAtLeastOne', { term: $t('complaintForm.ticket.battery.damage') })
        "
        :items="damageItems"
        multiple
        chips
        persistent-hint
        required
        v-on="getTouchListeners('formData.damage')"
      />

      <BaseTextarea
        v-model="formData.description"
        class="mb-6"
        :error-messages="descriptionErrors"
        :hide-details="!descriptionErrors.length"
        :label="$t('complaintForm.claim.description')"
        required
        v-on="getTouchListeners('formData.description')"
      />

      <ComplaintFormStepperControls
        :is-valid="isValid"
        :has-required-fields="true"
        :prev-step="prevStep"
        :next-step="submit"
      />
    </FormSection>
  </v-form>
</template>

<script>
import { get } from 'lodash-es'
import { mapMutations, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'

import StepperMixin from '@/js/mixins/stepper-mixin.js'
import FormValidationMixin from '@/js/components/Forms/mixins/form-validation-mixin.js'
import ComplaintFormMixin from '@/js/components/Forms/ComplaintForm/_mixins/complaint-form-default-mixin.js'

import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_MUTATION from '@/js/components/Forms/ComplaintForm/_store-module/mutation-types.js'
import FORM_GETTER from '@/js/components/Forms/ComplaintForm/_store-module/getter-types.js'

import FormSection from '@/js/components/Forms/FormSection.vue'

import ComplaintFormStepperControls from '../../ComplaintFormStepperControls.vue'

export default {
  name: 'ComplaintFormImpulseErrorDesc',
  components: {
    FormSection,
    ComplaintFormStepperControls,
  },
  mixins: [FormValidationMixin, ComplaintFormMixin],
  props: {
    ...StepperMixin.props,
  },
  data() {
    return {
      formData: {
        damage: null,
        description: null,
      },
    }
  },
  validations: {
    formData: {
      damage: {
        required,
      },
      description: {
        required,
      },
    },
  },
  computed: {
    /** Getters */
    ...mapGetters(FORM_CONSTANTS.STORE_ID, {
      steps: FORM_GETTER.STEPS,
    }),

    /** Store data */
    errorDescData() {
      return get(this.steps, FORM_CONSTANTS.SOURCE_DATA_CONSTANTS.STEPS.ERROR_INFOS, {})
    },

    /** Select items */
    damageItems() {
      return Object.entries(this.$t('complaintForm.ticket.battery.damage_type')).map(
        ([, value]) => ({ text: value, value }),
      )
    },

    /** Errors */
    damageErrors() {
      return this.formErrorHelper('formData.damage', [this.chooseError])
    },
    descriptionErrors() {
      return this.formErrorHelper('formData.description', [this.requiredError])
    },
  },
  methods: {
    ...mapMutations(FORM_CONSTANTS.STORE_ID, {
      updateFormData: FORM_MUTATION.UPDATE_FORM_DATA,
    }),
    submitCallback() {
      this.updateFormData(this.formData)
      this.nextStep()
    },
  },
}
</script>
<style lang="scss" module>
.select {
  :global(.v-chip) {
    color: var(--white) !important;

    background-color: var(--primary) !important;

    &:global(.v-chip--select) {
      margin: 0.5rem 0.25rem !important;
    }
  }
}
</style>
